import React, { useEffect, useRef } from 'react';

// eslint-disable-next-line react/prop-types
function HandleEnterKey({ children }) {
  const formRef = useRef(null); // Referência ao contêiner do formulário

  useEffect(() => {
    if (formRef.current) {
      // Obtém todos os elementos focáveis no formulário
      const focusableElements = Array.from(
        formRef.current.querySelectorAll('input, button, select')
      ).filter(
        (el) =>
          (el.tagName === 'INPUT' &&
            el.type !== 'hidden' &&
            !el.readOnly &&
            !el.disabled) ||
          (el.tagName === 'BUTTON' && !el.disabled) ||
          (el.tagName === 'SELECT' && !el.disabled)
      );

      // Define o foco no primeiro elemento habilitado
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();

      // Obtém todos os elementos focáveis no formulário
      const { form } = e.target;
      const focusableElements = Array.from(form.elements).filter(
        (el) =>
          (el.tagName === 'INPUT' &&
            el.type !== 'hidden' &&
            !el.readOnly &&
            !el.disabled) ||
          (el.tagName === 'BUTTON' && !el.disabled) ||
          (el.tagName === 'SELECT' && !el.disabled) ||
          (el.tabIndex >= 0 && !el.disabled)
      );

      // Encontra o índice do elemento atual
      const index = focusableElements.indexOf(e.target);
      if (index >= 0) {
        const nextElement =
          focusableElements[index + 1] || focusableElements[0]; // Volta ao primeiro elemento se for o último
        if (nextElement) {
          if (nextElement.closest('.MuiAutocomplete-root')) {
            const input = nextElement.querySelector('input');
            if (input) {
              input.focus();
              return;
            }
          }
          nextElement.focus();
        }
      }
    }
  };

  // Adiciona o evento onKeyDown a cada filho e encapsula no contêiner com ref
  return (
    <div ref={formRef}>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { onKeyDown: handleKeyDown })
      )}
    </div>
  );
}

export default HandleEnterKey;
